import Dialog from "../1. Core/Controls/Dialog/Dialog";

import Select from "../1. Core/Controls/Select/Select";
import TextField from "../1. Core/Controls/TextField/TextField";
import NP from "../1. Core/NP";
import {IJudge} from "./JudgesList";
import {getCountries} from "../10. Battle/Util";
import {IState} from "../2. Athletes/StatesList";
import {ServerAPI} from "../1. Core/ServerAPI";
import Delegate from "../1. Core/Delegate";

export default class EditJudgeDialog extends Dialog {

	EvChanged: Delegate;
	_Judge: IJudge;

	_firstNameField: TextField;
	_lastNameField: TextField;
	//_regionsCombo: Select;
	_qField: TextField;
	private _countryCombo: Select;


	_initFields(settings: object)
	{
		this.EvChanged = new Delegate();
		this._Judge = null;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = NP.RM.getString('Judge');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
	}

	_render()
	{
		super._render();

		this._firstNameField = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('FirstName')
		});

		this._lastNameField = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('LastName')
		});

		this._countryCombo = new Select({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Country')
			// EvItemSelected: () =>
			// {
			// 	getStates(this._countryCombo.getValue()).then((res: IState[]) =>
			// 	{
			// 		if (this._regionsCombo)
			// 		{
			// 			let items = res.map(state => ({Value: state.ISO, FontImage: NP.FontImages.geo, Content: state.Name}));
			// 			this._regionsCombo.addItems(items);
			// 			if (this._Judge)
			// 				this._regionsCombo.setValue(this._Judge.StateISO);
			// 		}
			// 	});
			// }
		});
		//
		// this._regionsCombo = new Select({
		// 	ParentNode: this._contentNode,
		// 	FloatingLabel: NP.RM.getString('State')
		// });

		this._qField = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString('Qualification')
		});

		getCountries(true).then((res: IState[]) =>
		{
			let items = res.map(state => ({Value: state.Id, FontImage: NP.FontImages.geo, Content: state.Name}));
			if (this._countryCombo)
			{
				this._countryCombo.setItems(items);

				if (this._Judge)
					this._countryCombo.setValue(this._Judge.CountryId);
			}
		});


		this._cancelButton.setIsVisible(false);


		this.refresh();
	}

	refresh()
	{
		if (this._Judge)
		{
			this._firstNameField.setValue(this._Judge.FirstName);
			this._lastNameField.setValue(this._Judge.LastName);
			this._qField.setValue(this._Judge.Qualification);
			this._countryCombo.setValue(this._Judge.CountryId);
		}
	}

	_onOkButtonClick()
	{
		ServerAPI.post(this._Judge ? `/judge/${this._Judge.Id}` : "/judge", {
			Id: this._Judge && this._Judge.Id,
			FirstName: this._firstNameField.getValue(),
			LastName: this._lastNameField.getValue(),
			Qualification: this._qField.getValue(),
			CountryId: this._countryCombo.getValue()
		}).then(() =>
		{
			this.EvChanged.fire(this);
			this.hide()
		});
	}
}